/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-05-10 14:06:24
 * @LastEditors: Please set LastEditors
 */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

import AddAloneHost from './AddAloneHost';
import Detail from '../Detail';

import styles from './index.less';

const Alone = () => {
  const { singleNodeId } = useSelector((state: reducerStates) => state.envManage);
  const [flag, setFlag] = useState('');
  useEffect(() => {
    setFlag(singleNodeId || '');
  }, [singleNodeId]);

  return (
    <div className={styles.alone_content}>
      {flag ? (
        <div className={styles.alone_detail}>
          <Detail />
        </div>
      ) : (
        <AddAloneHost />
      )}
    </div>
  );
};

export default Alone;
